<template>
  <div class="py-4 container-fluid">
    <!-- <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'export-excel/rfq?rfq_code='+search.rfq_code+'&vendor_code='+search.vendor_code+'&status='+search.status+''" target="_BLANK"><i class="fa fa-download fa-sm"></i> Export</a> -->
    <!-- <argon-button color="warning" size="sm" class="mb-3" variant="gradient" @click="modalImport()"><i class="fa fa-upload fa-sm"></i> Import</argon-button> -->
    <div class="row">
      <div class="col-lg-6 col-md-6 col-12">
        <card
          title="Paid"
          :value="(totPaid)"
          iconClass="fa fa-handshake"
          iconBackground="bg-gradient-success"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-6 col-md-6 col-12">
        <card
          title="Not Paid Yet"
          :value="(totNotYetPaid)"
          iconClass="fa fa-credit-card"
          iconBackground="bg-gradient-danger"
          directionReverse
        ></card>
      </div>
     <!--  <div class="col-lg-3 col-md-6 col-12">
        <card
          title="Fixed PO"
          :value="convertRp(totalPoApproved)"
          iconClass="fa fa-thumbs-up"
          iconBackground="bg-gradient-success"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <card
          title="Total PO"
          :value="convertRp(totalPo)"
          iconClass="ni ni-satisfied"
          iconBackground="bg-gradient-warning"
          directionReverse
        ></card>
      </div> -->
    </div>
    <div class="row">
      <div class="col-lg-8">
        <!-- CHART BAR DATA -->
        <div class="card mb-3"> 
          <div class="card-header pb-0 text-center align-content-center justify-content-center">
            <div class="row">
              <div class="col-12">
                <h6 class="text-center">CHART OF INVOICES PAID BY FINANCE</h6>
              </div>
             <!--  <div class="col-2">
                <select class="form-select" aria-label="Default select example" @change="changeBarChart()" v-model="yearBarChart">
                  <option value="2026" >2026</option>
                  <option value="2025" >2025</option>
                  <option value="2024" >2024</option>
                  <option value="2023" >2023</option>
                  <option value="2022" >2022</option>
                  <option value="2021" >2021</option>
                  <option value="2019" >2019</option>
                  <option value="2018" >2018</option>
                </select>
              </div> -->
            </div>
          </div>
          <div class="card-body mt-n3">
            <div class="pt-3 chart">
              <canvas id="chart-line" class="chart-canvas" height="250"></canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card mb-5"> 
          <div class="row">
            <div class="col-lg-12">
              <div class="card-header pb-0 text-center">
                <h6>INVOICE PAID BY FINANCE</h6>
              </div>
            </div>
            <!-- <div class="col-lg-6 float-right">
              <argon-button
                style="margin-right: 10px; margin-left: 60px;"
                class="mt-0"
                variant="gradient"
                color="secondary"
                size="sm"
                @click="filter()"
              ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
              <a class="btn btn-sm btn-success mt-3" style="margin-right: 10px;" :href="apiUrl+'export-excel/lead-time-item-category'" target="_BLANK"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
            </div> -->
          </div>
          <div class="card-body px-0 pt-0 pb-2 mt-0">
            <div class="table-responsive p-0">
              <table class="table table-sm table-hover table-striped align-items-center mb-0 mt-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">MONTH</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in tableInvoiceFinance.data " :key="i">
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold text-uppercase"> {{ row.period }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.total_amount) }} </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-lg-4">
                <div class="card-header pb-0">
                  <h6>Payment Management</h6>
                </div>
              </div>
              <div class="col-lg-4">
                <input type="text" class="form-control mt-3" placeholder="Search by PO NO." v-model="search.po_no" @keyup="get()">
              </div>
              <div class="col-lg-4 float-right">
                <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                <a class="btn btn-sm btn-success" style="margin-right: 10px; margin-top: 40px;" :href="apiUrl+'export-excel/payment-invoice-po?po_no='+search.po_no+'&vendor_name='+search.vendor_name['company_name']+'&term_payment='+search.term_payment+'&date_payment='+search.date_payment+'&proc_pic='+search.proc_pic+'&status='+search.status+''" target="_BLANK"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PO NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">VENDOR NAME</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">TOTAL ITEM</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PAYMENT TERM</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PERCENTAGE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">AMOUNT</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PAID</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ISSUE DATE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">TEMPO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PAYMENT DATE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PROC PIC</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">NOTE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-primary" style="cursor: pointer;">  {{ row.po_no }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.company_name }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase"> {{ row.total_item_count }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.term_payment }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.percentage }} %</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ convertRp(row.total_amount) }} </span>
                      </td>
                      <td class="align-middle text-center text-sm" style="background: #FFF8DC;">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ convertRp(row.total_amount * (row.percentage / 100)) }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ moment(row.issue_date).locale('id').format('LL') }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.periode }} Days</span>
                      </td>
                      <td class="align-middle text-center text-sm" style="background: #FFF8DC;">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ moment(row.date_payment).locale('id').format('LL') }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-success" v-if="row.status == 'Paid'"> {{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-danger" v-if="row.status == 'Not Yet Paid'"> {{ row.status }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.created_by }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.note }} </span>
                      </td>
                      <td class="align-middle text-center">
                        <!-- <i class="fa fa-check-circle-o" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="fixData(row.po_no)"></i> -->
                        <i class="fa fa-check fa-sm" aria-hidden="true" title="Tandai sudah dibayar" style="cursor: pointer; margin-right: 20px;" @click="paymentPaid(row.id)" v-if="row.status == 'Not Yet Paid'"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

   <!-- ================================================  MODAL FILTER ============================================== -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">PO No </label>
        <input type="text" class="form-control" placeholder="PO No" v-model="search.po_no" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Vendor </label>
        <multiselect v-model="search.vendor_name" :options="tableVendor.data" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Vendor Code" label="vendor_code" track-by="vendor_code" :preselect-first="true" @keyup="getVendor" :custom-label="nameWithLangVendor">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect> 
        <label for="example-text-input" class="form-control-label mt-3">Term Payment </label>
        <input type="text" class="form-control" placeholder="Term Payment" v-model="search.term_payment" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Payment Date </label>
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.date_payment"/>
        <label for="example-text-input" class="form-control-label mt-3">Status </label>
        <select class="form-select" aria-label="Default select example" v-model="search.status" v-on:keyup.enter="get()">
          <option value="Paid">PAID</option>
          <option value="Not Pid Yet">NOT PAID YET</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="search = {}">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

</template>

<script>
import Card from "@/examples/Cards/Card.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
var moment = require('moment');
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import Chart from "chart.js/auto";
import paymentProc from '@/services/procurement/paymentProc.service';
import purchasingRequisition from '@/services/procurement/purchasingRequisition.service';

export default {
  name: "tables",
  components: {
    Card,
    ArgonButton,
    VueFinalModal,
    Multiselect,
    BasePagination,
    flatPickr,
  },
  data() {
    return {
      pagination: {
        page_count: '',
        page: 1,
      },
      moment:moment,
      table: {
        data: []
      },
      tableLeadTime: {
        data: []
      },
      tableInvoiceFinance: {
        data: []
      },
      totPaid: '',
      totNotYetPaid: '',
      tableVendor: {
        data: []
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      onLoading: false,
      storageUrl : config.storageUrl,
      search: {
        po_no: '',
        vendor_name: '',
        term_payment: '',
        date_payment: '',
        proc_pic: '',
        status: '',
      },
      apiUrl :config.apiUrl,

      chartMonth: [],
      chartLineValue: [],

    };
  },
  mounted(){
    this.get();
    this.getInvoicePaidByFinance();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    nameWithLangVendor ({ vendor_code, company_name }) {
      return `${vendor_code} - ${company_name}`
    },
    get(param){
      let context = this; 
      context.onLoading = true;

      Api(context, paymentProc.index({po_no: this.search.po_no, vendor_name: this.search.vendor_name['company_name'], term_payment: this.search.term_payment, date_payment: this.search.date_payment, proc_pic: this.search.proc_pic, status: this.search.status, page: context.pagination.page})).onSuccess(function(response) {    
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page

          context.totPaid       = response.data.data.totPaid;
          context.totNotYetPaid = response.data.data.totNotYetPaid;

          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show = false;
         context.onLoading       = false;
      })
      .call()
    },
    getInvoicePaidByFinance(param){
      let context = this; 
      context.onLoading = true;

      Api(context, purchasingRequisition.getInvoiceFinance()).onSuccess(function(response) {    
          context.tableInvoiceFinance.data = response.data.data.data;

          context.chartMonth     = response.data.data.data.map(item => item.period);
          context.chartLineValue = response.data.data.data.map(item => item.total_amount);
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show = false;
         context.onLoading       = false;
         context.getChartLine();
      })
      .call()
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    paymentPaid(id){
      var r = confirm("Are you sure this PO has been Paid ?");
      if (r == true) {
        let api      = null;
        let context  = this;
        let formData = new FormData();

        formData.append('id', id);
        api = Api(context, paymentProc.paymentPaid(formData));
        api.onSuccess(function(response) {
          context.get();
          context.notify('Data Berhasil di Update', 'success')
        }).onError(function(error) { 
          context.notify(error.response.data.message, 'error')                   
        }).onFinish(function() { 
        })
        .call();
      }
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },
    convertRp(bilangan) {
      if (bilangan) {
        // var number_string = bilangan.toString(),
        //     sisa    = number_string.length % 3,
        //     rupiah  = number_string.substr(0, sisa),
        //     ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        // if(ribuan){
        //   var separator = sisa ? '.' : '';
        //   rupiah += separator + ribuan.join('.');
        //   return rupiah
        // }else{
        //   return bilangan
        // }

        var data =  Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR"
        }).format(bilangan);
        
        return data.substr(3)
      }
    },

    // CHART LINE
    getChartLine(){
      var ctx1 = document.getElementById("chart-line").getContext("2d");

      var gradientStroke1 = ctx1.createLinearGradient(0, 230, 0, 50);

      gradientStroke1.addColorStop(1, "rgba(94, 114, 228, 0.2)");
      gradientStroke1.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
      gradientStroke1.addColorStop(0, "rgba(94, 114, 228, 0)");

      new Chart(ctx1, {
        type: "line",
        data: {
          labels: Object.values(this.chartMonth),
          datasets: [
            {
              label: "Cost",
              tension: 0.4,
              borderWidth: 0,
              pointRadius: 0,
              borderColor: "#4BB543 ",
              backgroundColor: gradientStroke1,
              // eslint-disable-next-line no-dupe-keys
              borderWidth: 3,
              fill: true,
              data: Object.values(this.chartLineValue),
              maxBarThickness: 6,
            },
            // {
            //   label: "DB",
            //   tension: 0.4,
            //   borderWidth: 0,
            //   pointRadius: 0,
            //   borderColor: "#4BB543 ",
            //   backgroundColor: gradientStroke1,
            //   // eslint-disable-next-line no-dupe-keys
            //   borderWidth: 3,
            //   fill: true,
            //   data: [32,85,54,32],
            //   maxBarThickness: 6,
            // },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
          scales: {
            y: {
              grid: {
                drawBorder: false,
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                padding: 10,
                color: "#fbfbfb",
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
            x: {
              grid: {
                drawBorder: false,
                display: false,
                drawOnChartArea: false,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                color: "#ccc",
                padding: 20,
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
          },
        },
      });
    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
/*MODAL WIDTH KUSUS LEBAR BESAR*/
::v-deep .modal-content-width {
  /*display: flex;*/
  /*flex-direction: column;*/
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1090px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 500px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
</style>
